import { SortOrder } from 'further-types/utils';
import { z } from 'zod';
import isMongoId from '../../helpers/is-mongo-id';

export const GetInvestorsForTaxYearInput = z.object({
  taxYearStart: z.number().int(),
  firmId: z.string().refine(isMongoId()),
  page: z.number().int().min(1).optional(),
  rowsPerPage: z.number().int().min(1).optional(),
  order: z.nativeEnum(SortOrder).optional(),
  orderBy: z.string().optional(),
  search: z.string().optional(),
  isHardCopyOnly: z.boolean().optional(),
});

export const GetBulkTaxReportsInput = z.object({
  taxYearStart: z.number().int(),
  firmId: z.string().refine(isMongoId()),
  search: z.string().optional(),
  isHardCopyOnly: z.boolean().optional(),
});
